/** 体检单状态 */
export enum PhysicalOrderStatus {
  /** 待支付 */
  PENDING_PAYMENT = 1,
}

/** 体检预约状态 */
export enum PhysicalAppointmentStatus {
  /** 未预约 */
  NOT_APPOINMENT = 'NOT_APPOINMENT',
  /** 已预约 */
  APPOINMENT = 'APPOINMENT',
  /** 已到检 */
  SHOW = 'SHOW',
  /** 报告已生成 */
  REPORT_CREATED = 'REPORT_CREATED',
}

/** 体检预约状态(包含部分订单状态)对应说明 */
export const PhysicalAppointmentStatusText = {
  [PhysicalAppointmentStatus.NOT_APPOINMENT]: '未预约',
  [PhysicalAppointmentStatus.APPOINMENT]: '已预约',
  [PhysicalAppointmentStatus.SHOW]: '已到检',
  [PhysicalAppointmentStatus.REPORT_CREATED]: '报告已出',
};

/** 婚姻状况 */
export enum MaritalStatus {
  /** 未婚 */
  UNMARRIED = '10',
  /** 已婚 */
  MARRIED = '20',
}

/** 婚姻状况文本 */
export const MaritalStatusText = {
  [MaritalStatus.UNMARRIED]: '未婚',
  [MaritalStatus.MARRIED]: '已婚',
};

/** 是否可用-(校验保单过期情况) */
export enum AvailableEnum {
  /** 可用 */
  AVAILABLE = '1',
  /** 不可用 */
  UNAVAILABLE = '2',
}

/** 体检供应商 */
export enum SupplierEnum {
  /** 可东 */
  KD = 'KD',
  /** 善诊-团检 */
  SZ = 'SZ',
}
